module.exports = __webpack_public_path__ + "fonts/Lato-Heavy.72c6dd5.ttf";